/**
 * Calculates the area of a rectangle given its width and height
 */
var calculateArea = function calculateArea(width, height) {
  return width * height;
};
/**
 * Calculates the intersection area between two rectangles
 */
var calculateIntersectionArea = function calculateIntersectionArea(rect1, rect2) {
  var left = Math.max(rect1.left, rect2.left);
  var top = Math.max(rect1.top, rect2.top);
  var right = Math.min(rect1.right, rect2.right);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  if (left >= right || top >= bottom) {
    return 0;
  }
  return calculateArea(right - left, bottom - top);
};
/**
 * Calculates the total impacted area of a layout shift source
 * This is the sum of the previous and current areas minus their intersection
 */
export var getClsAttributionImpactedArea = function getClsAttributionImpactedArea(source) {
  var previousArea = calculateArea(source.previousRect.width, source.previousRect.height);
  var currentArea = calculateArea(source.currentRect.width, source.currentRect.height);
  var intersectionArea = calculateIntersectionArea(source.previousRect, source.currentRect);
  return previousArea + currentArea - intersectionArea;
};